/**
 * Referral Entity Definition
 */
import { ReferralCodeRelationSchema, ReferralRelationSchema } from "../schemas/relations";
import { defineEntity } from "./core";
import { getLazyUserEntityDef } from "./lazy-refs";
export const ReferralEntityDef = defineEntity({
    name: "referral",
    schema: ReferralRelationSchema,
    relations: {
        referee: { type: "one", entity: getLazyUserEntityDef },
        referrer: { type: "one", entity: getLazyUserEntityDef },
    },
});
export const ReferralCodeEntityDef = defineEntity({
    name: "referral-code",
    schema: ReferralCodeRelationSchema,
    relations: {
        referrer: { type: "one", entity: getLazyUserEntityDef },
    },
});
